import { SourcingStats } from 'api-clients/monolith';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';
import { Typography, TypographyVariant } from '@/components/ui/typography';
interface ConversionStatsProps {
  onClick?: () => void;
  stats: SourcingStats;
  typographyVariant?: TypographyVariant;
  className?: string;
  separator?: ReactNode | string;
  tooltipContent?: string;
}

export function ConversionStats({
  stats,
  onClick,
  typographyVariant = 'text',
  className,
  separator = '/',
  tooltipContent,
}: ConversionStatsProps) {
  const intl = useIntl();
  const addMessage = intl.formatMessage({ defaultMessage: '+ Add' });
  const { expected, actual } = stats;

  function StatValue({ children }: { children: string }) {
    return (
      <Typography variant={typographyVariant} className={className}>
        {children}
      </Typography>
    );
  }

  if (!expected && !actual)
    return onClick ? (
      <Button variant="link" size="link" onClick={onClick}>
        {addMessage}
      </Button>
    ) : (
      <StatValue>-</StatValue>
    );

  return (
    <div className="flex items-center gap-1">
      <StatValue>{`${actual ? `${actual}%` : '-'}`}</StatValue>

      {typeof separator === 'string' ? (
        <StatValue>{separator}</StatValue>
      ) : (
        separator
      )}

      {onClick ? (
        <Tooltip content={tooltipContent}>
          <Button
            variant="link"
            onClick={onClick}
            className={clsx({
              '!text-large font-medium': typographyVariant === 'large2',
            })}
          >
            {expected ? `${expected}%` : addMessage}
          </Button>
        </Tooltip>
      ) : (
        <StatValue>{expected ? `${expected}%` : '-'}</StatValue>
      )}
    </div>
  );
}
